import { useEffect, useRef, useState } from "react";
import { getItem, setItem } from "../../utils/token";
import AuthButton from "../LogInPage/LoginButton";
import { DashboardWidgets } from "./DashboardCards";
import { useLazyGetStartTestDataV1Query, useLazyRetrieveTestQuery, useResumeTestQuery } from "../../redux/API/StartTest/startTestApi";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrentModuleName, setCount, setCurrentTime,setExtraBreaks,setExtendedBreaks, setHasHighlightPopupBeenShown, setHighlightedContent,setIsModuleCompleted,setIsPopUp, setIsResumeTest, setMathModuleOneQuestions, setMathModuleTime, setQid, setReadingModuleOneQuestions, setResetFilters, setReviewPageClicked, setSelectTestType, setStartedTestId, setStrikedOptionsData, setTestId, setTestName, setUserTestId, setReadingModuleTime, setTestDifficulty, setIsTestInstructionsOpen, StartedTestId, setReadingModuleTwoQuestions, setMathModuleTwoQuestions, setIsTestStarted, setOptionStrikerButton } from "../../redux/Slices/startFullTestSlice";
import { RootState } from "../../redux/Store/store";
import { clearAnswers, retrieveMathsModuleOneAnswers, retrieveMathsModuleTwoAnswers, retrieveReadingModuleOneAnswers, retrieveReadingModuleTwoAnswers, setCurrentQuestion, setCurrentQuestionIndex } from "../../redux/Slices/resultSlice";
import { openDialog } from "../../redux/Slices/dialogSlice";
import FullTest from "../FullTest";
import TestInstructions from "../../components/Exam/TestInstructions";
import { addQuestionId } from "../../utils";
import DashboardBackground from "../../components/ReUsableComponents/DashboardBackground";
import SidebarV1 from "./SideBarV1";
import HeaderV1 from "./HeaderV1";
import SatPrep from "../../assets/Images/SATprep1.svg"
import { BiSolidRightArrow, BiTrash } from "react-icons/bi";
import { PiEyeBold } from "react-icons/pi";
import FullMarksLoader from "../../components/ReUsableComponents/FullMarksLoader";
import { useLocation, useNavigate } from "react-router-dom";

const DashboardV1 = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showTopFade, setShowTopFade] = useState(false);
  const [startDisable,setStartDisable] = useState(false);
  const [showScroll, setShowScroll] = useState(false);

  const {data,isSuccess,isError,refetch} = useResumeTestQuery({},{refetchOnMountOrArgChange:true});
  const [getStartTestDataV1] = useLazyGetStartTestDataV1Query();
  const [retrieveTest] = useLazyRetrieveTestQuery();

  const {
    startedTestId,
    isTestStarted,
    isTestInstructionsOpen
  } = useSelector((state: RootState) => ({
    startedTestId: state.root.startFullTest.startedTestId,
    isTestStarted: state.root.startFullTest.isTestStarted,
    isTestInstructionsOpen: state.root.startFullTest.isTestInstructionsOpen,
    previewTestData: state.root.startFullTest.previewTestData,
    selectTestType: state.root.startFullTest.selectTestType,
    readingTime: state.root.startFullTest.readModuleTime,
    mathTime: state.root.startFullTest.mathModuleTime,
    extraBreaks:state.root.startFullTest.extraBreaks,
    extendedBreaks:state.root.startFullTest.extendedBreaks,
  }));

  const startTest = async (isPreview: boolean) => {
    try {
      let body = {
        isPreviewTest: isPreview,
        isCustomTest: false,
        isFreeTest: isPreview ? false : startedTestId.isFirstTest,
        payload:{}
      }
      let response = await getStartTestDataV1(body);
      if (response.isSuccess) {
        dispatch(setIsTestInstructionsOpen(true));
        if (response.data.data) {
          localStorage.setItem(
            "currentTestName",
            response.data.data.testData.name
          );
          dispatch(setTestId(response.data.data.testData.testId));
          dispatch(setTestName(response.data.data.testData.name));

          let questions = response.data.data.testData.questions;
          let readingQuestions = questions[`ReadingAndWriting`];
          let mathsQuestions = questions[`Mathematics`];
          let readingModuleOneQuestions = [];
          let mathsModuleOneQuestions = [];

          if (response.data.data.testData.testType === "PREVIEW") {
            setItem("testType", "PREVIEW");
            readingModuleOneQuestions = addQuestionId(
              readingQuestions[`Module1`]
            );
            mathsModuleOneQuestions = addQuestionId(mathsQuestions[`Module1`]);
            dispatch(setReadingModuleOneQuestions(readingModuleOneQuestions));
            dispatch(setMathModuleOneQuestions(mathsModuleOneQuestions));
            dispatch(setUserTestId(response.data.data.testData.userTestId));
          }
        }

        dispatch(changeCurrentModuleName("writingModule1"));
        setStartDisable(false);
      } else {
        setStartDisable(false);
        console.error("Error:", response.error);
      }
    } catch (e) {
      setStartDisable(false);
      console.error("Error:", e);
    }
  };

  const handleStartTest = (isPreview: boolean) => {
    dispatch(setCount(""));
    dispatch(setHasHighlightPopupBeenShown(false));
    dispatch(setSelectTestType(""));
    dispatch(setExtraBreaks(false));
    dispatch(setExtendedBreaks(false));
    dispatch(setStrikedOptionsData([]));
    dispatch(setHighlightedContent([]));
    if (isPreview){
      setItem("testType", "PREVIEW");
      dispatch(setCurrentTime(0));
      startTest(true);
    } else {
      dispatch(openDialog("customSat"));
      dispatch(setCurrentTime(1920));
      dispatch(setReadingModuleTime(1920));
      dispatch(setMathModuleTime(2100));
      setItem("testType", "FULL");
    }
    dispatch(clearAnswers());
    dispatch(setReviewPageClicked(false));
    dispatch(setIsModuleCompleted(false));
    dispatch(setIsPopUp(false));
    dispatch(setIsResumeTest(false));
    dispatch(setTestDifficulty({ key: "Reading", value: 'MEDIUM' }));
    dispatch(setTestDifficulty({ key: "Math", value: 'MEDIUM' }));
  }

  const handleResumeTest = () => {
      setStartDisable(true);
      dispatch(setHasHighlightPopupBeenShown(false));
      resumeTest(startedTestId)
      dispatch(setReviewPageClicked(false));
      dispatch(setIsModuleCompleted(false));
      dispatch(setIsPopUp(false));
      setItem("testType", "FULL");
      dispatch(setIsResumeTest(true))
  }

  const resumeTest = async (item: StartedTestId) => {
          try {
              if (item.userTestId) {
              const response = await retrieveTest(item.userTestId);
              if (response.isSuccess) {
                  let moduleName =
                  response.data?.data?.additionalProps?.currentModuleName;
                  let count = response.data?.data?.additionalProps?.count;
                  localStorage.setItem("currentTestName", item.testName);
                  dispatch(setTestId(item.testId));
                  dispatch(setTestName(item.testName));
                  let strikedAndMarkedData =
                  response.data?.data?.additionalProps?.strikedAndMarkedData;
                  let highlightedContent =
                  response.data?.data?.additionalProps?.highlightedContent;
                  let time = response.data?.data?.additionalProps?.currentTime;
                  let reviewPage =
                  response.data?.data?.additionalProps?.reviewPageClicked;
                  dispatch(setStrikedOptionsData(strikedAndMarkedData));
                  dispatch(setHighlightedContent(highlightedContent));
                  dispatch(setReviewPageClicked(reviewPage));
                  dispatch(setOptionStrikerButton(response.data?.data?.additionalProps?.optionStrikerButton));
                  if (response.data.data) {
                      if (response?.data?.data?.isCustomTest){
                          dispatch(setSelectTestType('custom'));
                      }else{
                          dispatch(setSelectTestType('standard'));
                      } 
                      dispatch(
                          setReadingModuleTime(
                          response?.data?.data?.testDifficultyInfo?.["readingAndWriting"]
                              ?.time
                          )
                      );
                      dispatch(
                          setMathModuleTime(
                          response?.data?.data?.testDifficultyInfo?.["mathematics"]?.time
                          )
                      );
  
                      dispatch(
                          setTestDifficulty({
                          key:'Reading',
                              value:response?.data?.data?.testDifficultyInfo?.readingAndWriting.module1DifficultyLevel,
                          })
                      );
  
                      dispatch(
                          setTestDifficulty({
                          key:'Math',value: response?.data?.data?.testDifficultyInfo?.["mathematics"]
                              ?.module1DifficultyLevel,
                          })
                      );
  
                      if (response?.data?.data?.testDifficultyInfo?.extendedBreaks){
                          dispatch(setExtendedBreaks(true));
                      }
                      if (response?.data?.data?.testDifficultyInfo?.extraBreaks) {
                          dispatch(setExtraBreaks(true));
                      }
                      let questions = response.data.data.questionData;
                      let answersData = response.data.data.answerData;
  
                      let readingQuestions = questions[`ReadingAndWriting`];
                      let mathsQuestions = questions[`Mathematics`];
  
                      let mathAnswers = answersData[`Mathematics`];
                      let readingAnswers = answersData[`ReadingAndWriting`];
                      dispatch(setTestId(item.testId));
                      dispatch(setUserTestId(response.data.data.userTestId));
  
                      const readingModuleOneQuestions = addQuestionId(
                          readingQuestions[`Module1`]
                      );
                      const readingModuleTwoQuestions = addQuestionId(
                          readingQuestions[`Module2`]
                      );
                      const mathsModuleOneQuestions = addQuestionId(
                          mathsQuestions[`Module1`]
                      );
                      const mathsModuleTwoQuestions = addQuestionId(
                          mathsQuestions[`Module2`]
                      );
  
                      dispatch(setReadingModuleOneQuestions(readingModuleOneQuestions));
                      dispatch(setReadingModuleTwoQuestions(readingModuleTwoQuestions));
                      dispatch(setMathModuleOneQuestions(mathsModuleOneQuestions));
                      dispatch(setMathModuleTwoQuestions(mathsModuleTwoQuestions));
                      dispatch(retrieveMathsModuleOneAnswers(mathAnswers[`Module1`]));
                      dispatch(retrieveMathsModuleTwoAnswers(mathAnswers[`Module2`]));
                      dispatch(retrieveReadingModuleOneAnswers(readingAnswers[`Module1`]));
                      dispatch(retrieveReadingModuleTwoAnswers(readingAnswers[`Module2`]));
                      dispatch(changeCurrentModuleName(moduleName));
                      dispatch(setCount(count));
                      dispatch(setCurrentTime(time));
                      dispatch(setIsTestStarted(true));
                      if(location.pathname.includes("/practices/results") ){
                        navigate("/practices/results");
                      }
                      if(location.pathname.includes("/purchasehistory") || location.pathname.includes("/transactionsummary") || location.pathname.includes("/plans")){
                        navigate("/dashboard");
                      }
                  }
              }
                  setStartDisable(false);
              }
          } catch (e) {
              console.log(e,'error')
              setStartDisable(false);
          }
  };

  const openDiscard = () => {
    dispatch(openDialog("discardInfo"));
  }

  useEffect(() => {
   if(isSuccess && data){
    
    let payload = {
      testId : data.testId ?? [],
      testName: data.testname ?? "",
      createdDate: data.createdDate ?? "",
      userTestId : data?.userTestId ?? "",
      isFirstTest : data?.isFirstTest ?? false,
      loading: false,
    }
    dispatch(setStartedTestId(payload));
   }
   if(isError){
    let payload = {
      testId : [],
      testName: "",
      createdDate: "",
      userTestId : "",
      isFirstTest : false,
      loading : false
    }
    dispatch(setStartedTestId(payload));
   }
  },[data, isSuccess, isError, dispatch]);

  useEffect(()=>{
   localStorage.removeItem('route')
  },[])

  useEffect(() => {
    dispatch(setQid(""));
    dispatch(setCurrentQuestion(""));
    dispatch(setCurrentQuestionIndex(""));
    dispatch(setResetFilters());

    if (!isTestStarted) {
      refetch();
    }
  }, [isTestStarted]);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowScroll(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setShowScroll(false);
    }, 1000);
    
    const atTop = el.scrollTop === 0;
    setShowTopFade(!atTop);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    return () => {
      el?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const userRole = getItem("userRole");
  return (
    <>
    { startedTestId.loading ? (
        <div className="flex items-center justify-center h-screen w-full ">
          <FullMarksLoader height={200} width={200}/>
        </div>
      ) :isTestStarted ? <FullTest /> : isTestInstructionsOpen ? <TestInstructions /> : 
      <DashboardBackground>
        {(userRole === "STUDENT" ? (
            startedTestId.isFirstTest ? (
              <section className="flex flex-col justify-center items-center p-5 w-full h-full gap-3">

                <SidebarV1 isFirstTest={true}/>
                
                <div className="w-full flex items-center justify-center" style={{height:'calc(100vh - 9vh - 52px)'}}>
                  <div className="flex p-6 flex-col items-center rounded-[28px] bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
                    <img src={SatPrep} className="w-[321px]"/>
                    <div className="flex gap-6 justify-center items-center p-3 rounded-[18px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
                    <button
                      onClick={() => handleStartTest(true)}
                      disabled={startDisable}
                      className="text-base text-satPrepDarkAccent font-gully gap-[10px] font-medium flex py-[10px] px-5 items-center justify-center rounded-md border border-satPrepDarkAccent "
                    ><PiEyeBold size={22} className="mb-[2px]" /><span>Preview Test</span>
                    </button>
                    <div className="h-10 w-[2px] bg-satPrepGrey"></div>
                      {startedTestId.testId.length > 0 ? (
                        <div className="flex gap-6">
                          <AuthButton
                            text="Resume Test"
                            onClick={handleResumeTest}
                            disabled={startDisable}
                            className="font-gully text-lg"
                            icon={<BiSolidRightArrow size={22} />}
                            iconPosition="left"
                          />
                          <button
                            onClick={openDiscard}
                            className={`flex items-center justify-center py-[10px] px-[22px] rounded-md border border-satPrepRed  bg-satPrepWhite}`}
                          >
                            <BiTrash size={22} className="text-satPrepRed" />
                          </button>
                        </div>
                      ) : (
                        <AuthButton
                          text="Start Test"
                          onClick={() => handleStartTest(false)}
                          // disabled={startDisable}
                          className="font-gully text-lg"
                          icon={<BiSolidRightArrow size={22} className="mb-1" />}
                          iconPosition="left"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            ) : (
            <div className="p-5 flex gap-[1%] w-full">
              {/* Sidebar */}
              <SidebarV1 />

            <section className="flex flex-col justify-center items-start gap-[2vh]" style={{width: "calc(100vw - 240px)",height: "calc(100vh - 40px)"}}>
              
              <HeaderV1/>
              
              <div className="py-2 pr-1 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] border-[0.5px]  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive relative" style={{height: "calc(100vh - 12vh - 40px)"}}>
                <div ref={scrollRef} className={`h-full py-2 pl-3 w-full widgetScroll ${showScroll ? 'showScroll' : 'hideScroll'}`}>
                  <DashboardWidgets/>
                </div>
                {/* Top Gradient */}
                {showTopFade && (
                  <div
                    className="absolute top-2 left-3 z-10 h-10  pointer-events-none"
                    style={{
                      width: 'calc(100vw - 266px)',
                      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.56) 50%, rgba(255, 255, 255, 0.75) 100%)',
                    }}
                  />
                )}
                {/* Bottom Gradient */}
                <div 
                  className="absolute bottom-1 left-3 rounded-b-lg h-10 pointer-events-none"  
                  style={{
                    background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.56) 50%, rgba(255, 255, 255, 0.75) 100%)",
                    width: "calc(100vw - 266px)"
                  }}
                />
              </div>

            </section>
          </div>)
        ) : (
          <div className="flex items-center justify-center h-screen w-full ">
            <div className="flex flex-col bg-satPrepTransWhite h-fit py-5 px-10  rounded-[28px] shadow-widget-card backdrop-blur-sevenFive">
              <img src={SatPrep} className="w-[321px] mx-auto"/>
              <p className="text-3xl font-gully text-satPrepXDarkAccent">
                You are not authorized to access this page.
              </p>
            </div>
          </div>
        ))}
      </DashboardBackground>
    }
    </>
  );
};

export default DashboardV1;